import React, {Fragment, useEffect, useState} from 'react';
import {connect} from 'react-redux';
import './styles.scss';
import {compose} from 'redux';
import {strings} from '../../../../../util/strings';
import {setUser, setWizard} from '../../../../../store/actions';
import {Column, Row} from '../../../../../components/layout';
import * as fonts from '../../../../../util/fonts';
import {Link, useHistory} from 'react-router-dom';
import {
  capitalizeName,
  cleanProfessionalNameFromDr,
  formatDatePhrase,
  formatPhone as formatReference,
  getColor,
  getCurrencyCode,
  timeWithTimezone,
} from '../../../../../util/utility';
import noPhotoDoctor from '../../../../../assets/medico_sem_foto.png';
import colors from '../../../../../util/colors';
import starIcon from '../../../../../assets/Star.png';
import starEmptyBorder from '../../../../../assets/star-empty-border.png';
import blackVideoIcon from '../../../../../assets/consulta-black-video-icon.svg';
import mbWayIcon from '../../../../../assets/MBway.svg';
import creditCardIcon from '../../../../../assets/CreditCard.svg';
import multiBancoIcon from '../../../../../assets/MultiBanco.svg';
import {Rating} from '@mui/material';
import moment from 'moment';
import {Icons} from '../../../../../util/icons';
import Icon from '../../../../../components/icon';
import AppButton from '../../../../../components/app-button';
import FilledRadioButton from '../icons/FilledRadioButton';
import UnfilledRadioButton from '../icons/UnfilledRadioButton';
import {post, put} from '../../../../../api/api';
import {
  uriPostAppointment,
  uriPutAppointment,
} from '../../../../../api/endpoints';
import ModalTemplate from '../../../../../components/modal';
import {useMediaQuery} from 'react-responsive';
import Header2 from '../../../../../components/headers/header2';
import * as Yup from 'yup';
import AppForm from '../../../../../components/forms/AppForm';
import AppFormField from '../../../../../components/forms/AppFormField';
import AppFormSubmitButton from '../../../../../components/forms/AppFormSubmitButton';

interface ScheduledAppointmentDetailsProps {
  buStyles: any;
  selectedBu: any;
  labels: typeof strings.pt.appointments;
  labelsProfile: typeof strings.pt.myProfile;
  user: any;
  wizard: any;
  availableBus: any;
  editingAppointmentId?: number;
  onSubmit(values: any): any;
  setWizard(value: any): void;
  setUser(value: any): void;
}

enum Bu {
  notClient = 'NOTCLIENT',
}

function ScheduledAppointmentDetails({
  buStyles,
  selectedBu,
  labels,
  labelsProfile,
  wizard,
  user,
  availableBus,
  editingAppointmentId,
  setWizard,
  setUser,
}: ScheduledAppointmentDetailsProps) {
  const [seeMore, setSeeMore] = useState(false);
  const [appointmentSlotDetails, setAppointmentSlotDetails] =
    useState<any>(null);
  const [doctorSpecialities, setDoctorSpecialities] = useState('');
  const [languages, setLanguages] = useState('');
  const [showGeneralError, setShowGeneralError] = useState(false);
  const [errorMessage, setErrorMessage] = useState<any>(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [appointmentId, setAppointmentId] = useState<any>(null);
  const [disableButton, setDisableButton] = useState<any>(null);
  const [showPendingPopup, setShowPendingPopup] = useState(false);
  const [hidePayment, setHidePayment] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState('mbw');
  const [paymentExpiresAt, setPaymentExpiresAt] = useState('');
  const [creditPaymentUrl, setCreditPaymentUrl] = useState('');
  const [mbPaymentInfo, setMbPaymentInfo] = useState({
    entity: '',
    reference: '',
    amount: '',
  });
  //const [updateMyDataCheck, setUpdateMyDataCheck] = useState(false);
  const [labelSpecialtyAlerts, setLabelSpecialtyAlerts] = useState('');

  const featureName = 'ScheduledAppointmentDetails';

  const history = useHistory();

  const isResponsive = useMediaQuery({maxDeviceWidth: 768});
  const academicBackground = appointmentSlotDetails?.academicBackground;

  useEffect(() => {
    setAppointmentSlotDetails(wizard.appointmentSlot);
    if (
      parseFloat(wizard.appointmentSlot.videoPriceWithCurrency).toFixed(2) ===
        '0.00' ||
      editingAppointmentId
    ) {
      setHidePayment(true);
    }
    let labelSpecialty = wizard?.patientInsurance?.specialities?.find(
      (specialty: any) =>
        specialty?.specialtyAlias === wizard?.state?.specialitySlug
    )?.specialtyAlerts;

    setLabelSpecialtyAlerts(labelSpecialty);
  }, []);

  useEffect(() => {
    if (appointmentSlotDetails) {
      joinSpecialities(appointmentSlotDetails.specialties);
      joinLanguages(appointmentSlotDetails.languages);
    }
  }, [appointmentSlotDetails]);

  const loadNoPhotoDoctor = (event: any) => {
    event.target.src = noPhotoDoctor;
  };

  const isNotClient = selectedBu.buId === Bu.notClient;

  const patientName = isNotClient
    ? `${user.name}`
    : wizard.patientInsurance.patient.memberName;

  const joinSpecialities = (specialities: any[]) => {
    const specialitiesNames: any[] = [];
    specialities.forEach((speciality) =>
      specialitiesNames.push(speciality.name)
    );
    const allSpecialities = specialitiesNames.join(', ');
    setDoctorSpecialities(allSpecialities);
  };

  const joinLanguages = (languages: any[]) => {
    const languagesNames: any[] = [];
    languages.forEach((language) => languagesNames.push(language.name));
    const allLanguages = languagesNames.join(', ');
    setLanguages(allLanguages);
  };

  const renderPatient = () => {
    return (
      <div className="appointment-slot-patient-name appointment-linear-gradient appointment-border-radius">
        {labels?.appointments_detail_patient}{' '}
        <span className="bolder-text">{capitalizeName(patientName)}</span>
      </div>
    );
  };

  const renderMedic = () => {
    return (
      <div className="appointment-slot-doctor-info-container appointment-linear-gradient">
        <div className="appointment-slot-doctor-info-flex">
          <img
            src={appointmentSlotDetails?.photo?.normal || noPhotoDoctor}
            alt="doctor-picture"
            onError={loadNoPhotoDoctor}
            className="appointment-slot-doctor-image appointment-slot-doctor-image-border"
            style={getColor('borderColor')}
          />

          <div className="appointment-slot-doctor-info">
            <p
              className="appointment-slot-doctor-name"
              style={getColor('color', colors.black)}>
              {cleanProfessionalNameFromDr(appointmentSlotDetails?.name)}
            </p>
            <p className="appointment-slot-doctor-specialities">
              {doctorSpecialities}
            </p>
            <div className="appointment-slot-doctor-rating">
              <Rating
                defaultValue={
                  parseFloat(
                    appointmentSlotDetails?.doctor?.rating ||
                      appointmentSlotDetails?.rating ||
                      0
                  ) / 2
                }
                precision={0.01}
                readOnly
                icon={<img src={starIcon} alt="star-icon" width={10} />}
                emptyIcon={
                  <img
                    src={starEmptyBorder}
                    alt="star-empty-border-icon"
                    width={10}
                  />
                }
              />
            </div>
          </div>
        </div>
        {(languages || academicBackground) && (
          <div className="appointment-slot-doctor-curricular-info">
            <p className="appointment-slot-doctor-curricular">
              {labels?.appointments_detail_curricular_info}
            </p>
            {languages && (
              <>
                <p className="appointment-slot-doctor-languages-title">
                  {labels?.appointments_detail_languages}
                </p>
                <p className="appointment-slot-doctor-languages">
                  {languages}{' '}
                  <span>
                    {!seeMore && academicBackground && (
                      <span
                        className="appointment-slot-see-more"
                        style={getColor('color')}
                        onClick={() => {
                          setSeeMore(true);
                        }}>
                        {labels?.see_more}
                      </span>
                    )}
                  </span>
                </p>
              </>
            )}
            {seeMore && academicBackground && (
              <>
                <p className="appointment-slot-doctor-academic-title">
                  {labels?.appointments_detail_academic_background}
                </p>
                <p className="appointment-slot-doctor-academic-info">
                  {academicBackground}
                  <span>
                    {seeMore && (
                      <span
                        className="appointment-slot-see-more"
                        style={getColor('color')}
                        onClick={() => {
                          setSeeMore(false);
                        }}>
                        {labels?.see_less}
                      </span>
                    )}
                  </span>
                </p>
              </>
            )}
          </div>
        )}
      </div>
    );
  };

  const formatDate = (date: any, phraseParts: any) => {
    return date.format(phraseParts);
  };

  const renderDate = () => {
    return (
      appointmentDate && (
        <div className="appointment-slot-appointment-date-status appointment-linear-gradient appointment-border-radius">
          <img
            src={blackVideoIcon}
            alt="black-video-icon"
            width={18}
            className="appointment-slot-black-video-icon"
          />
          <div>
            <span>
              {isAppointmentToday
                ? labels?.appointments_today +
                  formatDate(
                    appointmentDate,
                    ` [${labels?.appointments_at}] HH:mm`
                  )
                : isAppointmentTomorrow
                ? labels?.appointments_tomorrow +
                  formatDate(
                    appointmentDate,
                    ` [${labels?.appointments_at}] HH:mm`
                  )
                : formatDatePhrase(
                    appointmentDate,
                    labels?.appointments_date_pattern
                  )}
            </span>
          </div>
        </div>
      )
    );
  };

  const renderMedicalData = () => {
    return (
      <div
        className="appointment-slot-appointment-medical-data-container appointment-linear-gradient appointment-border-radius"
        style={{marginBottom: '20px'}}>
        <Row className="appointment-medical-data-text" style={{...fonts.MM}}>
          {labels?.appointments_schedule_medical_data_title}
        </Row>
        <Row className="appointment-medical-data-text" style={{...fonts.SM}}>
          {labels?.appointments_schedule_medical_data_description}
        </Row>
        {!isResponsive && (
          <Row className="medical-data-container">
            <Column className="patient-number-column">
              <span style={{...fonts.SM}} className="patient-number-label">
                {labels?.appointment_schedule_patient_number_label}
              </span>
              <AppFormField
                name="patientNumber"
                placeholder={
                  labels?.appointments_schedule_insert_patient_number
                }
                maxLength={9}
                className="patient-number-input"
                showErrorMessage
              />
            </Column>
            <Column className="separator-column"></Column>
            <Column className="medical-data-phone-column">
              <Column>
                <span style={{...fonts.SM}} className="phone-label">
                  {labels?.appointment_schedule_medical_data_phone_label}
                </span>
                <Row>
                  <AppFormField
                    name="medicalDataPhone"
                    placeholder={labels?.appointments_schedule_insert_phone}
                    className="medical-data-phone-input"
                    showErrorMessage
                  />
                </Row>
                {/* <Row>
                  <AppCheckboxInput
                    className="medical-data-checkbox"
                    checked={updateMyDataCheck}
                    onChange={(value: boolean) => {
                      setUpdateMyDataCheck(value);
                    }}
                    labelClass="card-details-checkbox-label-text"
                    label={labels?.appointment_schedule_checkbox_data}
                  />
                </Row> */}
              </Column>
            </Column>
          </Row>
        )}
        {isResponsive && (
          <>
            <Row className="medical-data-container">
              <Column>
                <span style={{...fonts.SM}} className="patient-number-label">
                  {labels?.appointment_schedule_patient_number_label}
                </span>
                <AppFormField
                  name="patientNumber"
                  placeholder={
                    labels?.appointments_schedule_insert_patient_number
                  }
                  className="patient-number-input"
                  maxLength={9}
                  showErrorMessage
                />
              </Column>
            </Row>
            <Row className="medical-data-container">
              <Column>
                <span style={{...fonts.SM}} className="phone-label">
                  {labels?.appointment_schedule_medical_data_phone_label}
                </span>
                <Row>
                  <AppFormField
                    name="medicalDataPhone"
                    placeholder={labels?.appointments_schedule_insert_phone}
                    className="medical-data-phone-input"
                    showErrorMessage
                  />
                </Row>
                {/* <Row>
                  <AppCheckboxInput
                    className="medical-data-checkbox"
                    checked={updateMyDataCheck}
                    onChange={(value: boolean) => {
                      setUpdateMyDataCheck(value);
                    }}
                    labelClass="card-details-checkbox-label-text"
                    label={labels?.appointment_schedule_checkbox_data}
                  />
                </Row> */}
              </Column>
            </Row>
          </>
        )}
      </div>
    );
  };

  const appointmentDate: any =
    appointmentSlotDetails?.appointmentSlots[0].startTime &&
    timeWithTimezone(appointmentSlotDetails.appointmentSlots[0].startTime);

  let today = new Date();
  let isAppointmentToday = moment(appointmentDate).isSame(today, 'day');

  let tomorrow = moment(today).add(1, 'days');
  let isAppointmentTomorrow = moment(appointmentDate).isSame(tomorrow, 'day');

  // Validation schema for the form
  const validationSchema = Yup.object().shape({
    patientNumber: Yup.string().matches(
      /^\d{9}$/,
      strings.pt.messages.invalidFormat
    ),
    medicalDataPhone: Yup.string().matches(
      /^\+*\d{9,}$/,
      strings.pt.messages.invalidFormat
    ),
    paymentPhone: Yup.string().when([], {
      is: () => paymentMethod === 'mbw' && !hidePayment,
      then: (schema: any) =>
        schema
          .required(strings.pt.messages.requiredField)
          .matches(/^((^[0-9+]{9,}))$/, strings.pt.messages.invalidFormat),
      otherwise: (schema: any) => schema.notRequired(),
    }),
  });

  const renderSpecialtyLabel = () => {
    return (
      <div className="appointment-slot-appointment-speciality-warning appointment-linear-gradient appointment-border-radius">
        <div className="appointment-specialties-warning-and-input">
          <div className="appointment-slot-specialties-warning-div">
            <Column>
              <Icon
                width="24"
                height="24"
                className="appointment-slot-specialty-warning-icon"
                name={Icons.ALERT_PROBLEM}
                color={colors.alertRed}
                changeViewbox
                viewBox={'0 0 24 24'}
              />
            </Column>
            <Column>
              <span className="appointment-slot-payment-warning-text">
                {labelSpecialtyAlerts}
              </span>
            </Column>
          </div>
        </div>
      </div>
    );
  };

  const renderPayment = () => {
    const getPaymentExpiresAt = (method: string) => {
      setPaymentExpiresAt(
        moment()
          .add(
            parseInt(eval(`labels?.appointments_payment_expires_in_${method}`)),
            'minutes'
          ) // minutos, label BO
          .format(`[ ${labels?.appointments_until}] HH:mm[.]`)
      );
    };

    if (!paymentExpiresAt) getPaymentExpiresAt(paymentMethod);

    const onPaymentMethodSelected = (method: string) => {
      setPaymentMethod(method);
      getPaymentExpiresAt(method);
    };

    return (
      <div className="appointment-slot-payment-container appointment-linear-gradient no-padding-horizontal">
        <div className="appointment-slot-payment-container">
          <p className="appointment-slot-payment-methods-title">
            {labels?.appointments_choose_payment_method}
          </p>
          <div className="align-self-center">
            <span className="appointment-slot-payment-total">
              {labels?.appointments_total}
            </span>
            <span className="appointment-slot-payment-total-amount">
              {parseFloat(
                appointmentSlotDetails.videoPriceWithCurrency
              ).toFixed(2)}{' '}
              {getCurrencyCode(appointmentSlotDetails.currency, 'appointments')}
            </span>
          </div>
        </div>
        <div className="appointment-slot-payment">
          <div className="appointment-slot-payment-way-container">
            <div
              className="appointment-slot-radio-buttons"
              onClick={() => onPaymentMethodSelected('cc')}>
              {paymentMethod === 'cc' ? (
                <FilledRadioButton />
              ) : (
                <UnfilledRadioButton />
              )}
            </div>
            <img
              src={creditCardIcon}
              alt="credit-card-icon"
              width={35}
              height={16}
              className="appointment-slot-payment-icon"
            />
            <span className="appointment-slot-payment-way">
              {labels?.appointments_detail_payment_cc}
            </span>
          </div>

          <div className="appointment-slot-payment-way-container">
            <div
              className="appointment-slot-radio-buttons"
              onClick={() => onPaymentMethodSelected('mb')}>
              {paymentMethod === 'mb' ? (
                <FilledRadioButton />
              ) : (
                <UnfilledRadioButton />
              )}
            </div>
            <img
              src={multiBancoIcon}
              alt="bank-icon"
              width={35}
              height={25}
              className="appointment-slot-payment-way-icon"
            />
            <span className="appointment-slot-payment-way">
              {labels?.appointments_detail_payment_mb}
            </span>
          </div>

          <div className="appointment-slot-payment-way-container">
            <div
              className="appointment-slot-radio-buttons"
              onClick={() => onPaymentMethodSelected('mbw')}>
              {paymentMethod === 'mbw' ? (
                <FilledRadioButton />
              ) : (
                <UnfilledRadioButton />
              )}
            </div>
            <img
              src={mbWayIcon}
              alt="mbway-icon"
              width={35}
              height={25}
              className="appointment-slot-payment-way-icon"
            />
            <span className="appointment-slot-payment-way">
              {labels?.appointments_detail_payment_mbw}
            </span>
          </div>
        </div>

        <div className="appointment-slot-appointment-payment-warning border-top-white appointment-payment-warning">
          <div className="appointment-slot-warning-and-input">
            {/* if payment way is mbway */}
            {paymentMethod === 'mbw' && (
              <AppFormField
                name="paymentPhone"
                placeholder={labelsProfile?.myProfile_phoneNumberLabel}
                showErrorMessage
              />
            )}
            {/* end if payment way is mbway */}
            <div className="appointment-slot-warning-div">
              <Icon
                width="24"
                height="24"
                className="appointment-slot-payment-warning-icon"
                name={Icons.ALERT_PROBLEM}
                color={colors.alertRed}
                changeViewbox
                viewBox={'0 0 24 24'}
              />
              <span className="appointment-slot-payment-warning-text">
                {labels?.appointments_schedule_pay_until}
                {paymentExpiresAt}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const setAppointment = async (values: any) => {
    var body = null;
    const isNotClient = selectedBu.buId === Bu.notClient;
    var avBus = Object.values(availableBus);

    const loggedInUser: any = avBus.find(
      (bu: any) =>
        bu.buId === selectedBu.buId &&
        bu.famId === selectedBu.famId &&
        bu.nif === user.nif
    );

    // Get form values
    const paymentPhone = values?.paymentPhone || null;
    const patientNumber = values?.patientNumber || '';
    const medicalDataPhone = values?.medicalDataPhone || '';

    if (isNotClient) {
      body = {
        doctorId: appointmentSlotDetails?.id,
        autenticatedPerson: {
          buId: 'NOTCLIENT',
          memId: user.nif,
          birthdate: user.birthdate,
          name: `${user.name}`,
          phone: medicalDataPhone !== '' ? medicalDataPhone : user?.mobile,
          email: user?.email,
          nif: user.nif,
          national_health_service_number: patientNumber,
        },
        patient: {
          buId: 'NOTCLIENT',
          memId: user.nif,
          birthdate: user.birthdate,
          name: `${user.name}`,
          nif: user.nif,
        },
        providerID: appointmentSlotDetails?.providerId,
        startDateTime: appointmentSlotDetails?.appointmentSlots[0]?.startTime,
        paymentMethod: paymentMethod,
        ...(paymentPhone && {paymentPhone: paymentPhone}),
        amount: parseFloat(
          appointmentSlotDetails?.videoPriceWithCurrency
        ).toFixed(2),
        sessionId: appointmentSlotDetails.sessionId,
      };
    } else {
      var buId: any = loggedInUser?.buId || 'NOTCLIENT';
      var memId: any =
        buId === 'NOTCLIENT'
          ? selectedBu.nif
          : loggedInUser?.memId || selectedBu.nif;

      body = {
        doctorId: appointmentSlotDetails?.id,
        autenticatedPerson: {
          buId: buId,
          memId: memId,
          birthdate: user.birthdate,
          name: `${user.name}`,
          phone: medicalDataPhone !== '' ? medicalDataPhone : user?.mobile,
          email: user?.email,
          nif: user.nif,
          national_health_service_number: patientNumber,
        },
        patient: {
          buId: selectedBu?.buId,
          memId: selectedBu?.memId,
          birthdate: selectedBu?.dob,
          name: wizard?.patientInsurance?.patient?.memberName,
          nif: selectedBu?.nif,
        },
        providerID: appointmentSlotDetails?.providerId,
        startDateTime: appointmentSlotDetails?.appointmentSlots[0]?.startTime,
        paymentMethod: paymentMethod,
        ...(paymentPhone && {paymentPhone: paymentPhone}),
        amount: parseFloat(
          appointmentSlotDetails?.videoPriceWithCurrency
        ).toFixed(2),
        sessionId: appointmentSlotDetails.sessionId,
      };
    }

    // if (updateMyDataCheck) {
    //   let updateProfileBody = {
    //     userName: user.sub,
    //     fullName: `${user.given_name} ${user.family_name}`,
    //     nif: user.nif,
    //     phoneNumber: medicalDataPhone,
    //     email: user.email,
    //   };
    //   try {
    //     setDisableButton(true);
    //     await patch(uriUpdateUserdata(), updateProfileBody, featureName).then(
    //       () => {
    //         setUser({...user, phone_number: medicalDataPhone});
    //       }
    //     );
    //   } catch {}
    // }

    try {
      setDisableButton(true);
      if (editingAppointmentId) {
        await put(
          uriPutAppointment(
            appointmentSlotDetails?.providerId,
            editingAppointmentId
          ),
          body,
          featureName
        ).then((res: any) => {
          if (res?.data?.appointmentStatus === 'booked') {
            setShowSuccessModal(true);
          } else {
            setShowPendingPopup(true);
          }
          setAppointmentId((res?.data as any).appointmentId);
        });
      } else {
        await post(
          uriPostAppointment(),
          JSON.stringify(body),
          false,
          featureName
        ).then((res: any) => {
          if (res?.data?.paymentData.status === 'pending_payment') {
            var details = res?.data?.paymentData.paymentDataDetail;
            if (paymentMethod === 'cc') {
              let url = details.url;
              setCreditPaymentUrl(url);
              window.open(url, '_blank');
            }
            if (paymentMethod === 'mb') {
              setMbPaymentInfo(details);
            }
            setShowPendingPopup(true);
          } else {
            setShowSuccessModal(true);
          }
          setAppointmentId((res?.data as any).id);
        });
      }
    } catch (error: any) {
      if (typeof error.text !== 'function') {
        setShowGeneralError(true);
      } else {
        const errorText = await error.text();
        if (errorText) {
          const err = JSON.parse(errorText);
          if (Array.isArray(err.errors)) {
            const emailError = err.errors?.find(
              (el: any) => el.parameter === 'email'
            );

            if (emailError) {
              setErrorMessage(labels?.appointments_email_error);
              setEmailError(true);
            }
          }
        }
        setShowGeneralError(true);
      }
    } finally {
      setDisableButton(false);
    }
  };

  const renderNewAppointmentModal = () => (
    <ModalTemplate
      className="appointment-cancel-container"
      contentClassName="appointment-cancel-content"
      show={showSuccessModal}
      onHide={() => {
        setShowSuccessModal(false);
        history.push({
          pathname: '/consultas-online',
          state: {
            appointmentId: appointmentId,
            providerId: appointmentSlotDetails?.providerId,
            specialty: wizard?.state?.specialitySlug,
          },
        });
      }}
      cross={true}
      hideFooter={true}
      size="sm"
      lockClickOutside={true}>
      <div className="modal-error-container">
        <Row className="my-profile-submit-button-row">
          <Icon
            name={Icons.SUCCESS}
            width={'40'}
            height={'40'}
            color={colors.black}
            changeViewbox
            viewBox={'0 0 24 24'}
          />
        </Row>
        <Row className="errorPopup-title-row">
          <p
            style={{...fonts.MM, ...fonts.Bold, color: colors.black}}
            className="p-errorPopup">
            {labels?.appointments_confirmed}
          </p>
        </Row>
        <Row>
          <p style={fonts.M}>
            {labels?.appointment_created_successfully_description}
          </p>
        </Row>
        <Row className="my-profile-submit-button-row">
          <AppButton
            title="Ok"
            variant="secondary"
            onClick={() => {
              setShowSuccessModal(false);
              history.push({
                pathname: '/consultas-online',
                state: {
                  appointmentId: appointmentId,
                  providerId: appointmentSlotDetails?.providerId,
                  specialty: wizard?.state?.specialitySlug,
                },
              });
            }}>
            Ok
          </AppButton>
        </Row>
      </div>
    </ModalTemplate>
  );

  const renderChangeAppointmentModal = () => (
    <ModalTemplate
      className="appointment-cancel-container"
      contentClassName="appointment-cancel-content"
      show={showSuccessModal}
      onHide={() => {
        setShowSuccessModal(false);
        history.push({
          pathname: '/consultas-online',
          state: {
            appointmentId: appointmentId,
            providerId: appointmentSlotDetails?.providerId,
            specialty: wizard?.state?.specialitySlug,
          },
        });
      }}
      cross={true}
      hideFooter={true}
      size="sm"
      lockClickOutside={true}>
      <div className="modal-error-container">
        <Row className="health-data-title-row">
          <p
            style={{...fonts.L, ...fonts.SemiBold, color: colors.black}}
            className="p-myProfilePopup">
            {labels?.appointment_change_popup_title}
          </p>
        </Row>
        <Row className="my-profile-submit-button-row">
          <Icon
            name={Icons.SUCCESS}
            width={'40'}
            height={'40'}
            color={colors.black}
            changeViewbox
            viewBox={'0 0 24 24'}
          />
        </Row>

        <Row
          style={{...fonts.MM, ...fonts.Medium}}
          className="my-profile-modal-success">
          {labels?.appointments_change_confirm}
        </Row>
        <Row
          style={{...fonts.MM, ...fonts.Light}}
          className="my-profile-modal-success">
          {labels?.appointments_change_confirm_text}
        </Row>
        <Row className="my-profile-submit-button-row">
          <AppButton
            title="Ok"
            className="continue-button"
            variant="secondary"
            onClick={() => {
              setShowSuccessModal(false);
              history.push({
                pathname: '/consultas-online',
                state: {
                  appointmentId: appointmentId,
                  providerId: appointmentSlotDetails?.providerId,
                  specialty: wizard?.state?.specialitySlug,
                },
              });
            }}>
            {labels?.appointments_change_confirm_btn_label}
          </AppButton>
        </Row>
      </div>
    </ModalTemplate>
  );

  const renderSuccessModal = () => {
    return editingAppointmentId
      ? renderChangeAppointmentModal()
      : renderNewAppointmentModal();
  };

  const renderPendingModal = () => {
    const mbPaymentDetails = {
      [labels?.appointments_detail_payment_mb_entity]: mbPaymentInfo['entity'],
      [labels?.appointments_detail_payment_mb_reference]: formatReference(
        mbPaymentInfo['reference']
      ),
      [labels?.appointments_detail_payment_mb_amount]: `${parseFloat(
        mbPaymentInfo['amount']
      ).toFixed(2)} ${mbPaymentInfo['amount']?.split(' ')[1]}`,
    };

    return (
      <ModalTemplate
        className="appointment-popup-modal"
        inputType="confirm"
        show={showPendingPopup}
        onHide={() => {
          setShowPendingPopup(false);
          history.push({
            pathname: '/consultas-online',
            state: {
              appointmentId: appointmentId,
              providerId: appointmentSlotDetails?.providerId,
              specialty: wizard?.state?.specialitySlug,
            },
          });
        }}
        cross={true}
        hideFooter={true}>
        <Column className="appointment-popup-container">
          <Header2
            style={{...fonts.XL, color: colors.black, fontWeight: 'bolder'}}
            className="appointment-popup-container-title">
            {labels?.appointments_choosePatient_header}
          </Header2>
          <div>
            <Icon
              width="24"
              height="24"
              className="appointment-popup-error-icon"
              name={Icons.ALERT_PROBLEM}
              color={colors.alertRed}
              changeViewbox
              viewBox={'0 0 24 24'}
            />
          </div>
          <div className="appointment-error-text">
            {labels?.appointments_payment_pending}
          </div>
          <div className="appointment-error-text-2">
            {paymentMethod === 'cc' && (
              <Fragment>
                {labels?.appointments_payment_pending_confirm_cc}
                <a
                  className="appointment-payment-link"
                  href={creditPaymentUrl}
                  target="_blank">
                  {labels?.appointments_payment_pending_confirm_cc_link}
                </a>
                .
              </Fragment>
            )}
            {paymentMethod === 'mb' &&
              labels?.appointments_payment_pending_confirm_mb}
            {paymentMethod === 'mbw' &&
              labels?.appointments_payment_pending_confirm_mbw}
          </div>
          {paymentMethod === 'mb' && (
            <div className="appointment-mb-details-container appointment-pending-payment-container">
              {Object.entries(mbPaymentDetails).map(([key, value], i) => (
                <Row className="appointment-mb-details-row" key={i}>
                  <Column className="appointment-mb-details-title">
                    <span>{key}</span>
                  </Column>
                  <Column className="appointment-mb-details-value">
                    <span>{value}</span>
                  </Column>
                </Row>
              ))}
            </div>
          )}
          <AppButton
            className="appointment-popup-button-confirm"
            variant="secondary"
            onClick={() => {
              setShowPendingPopup(false);
              history.push({
                pathname: '/consultas-online',
                state: {
                  appointmentId: appointmentId,
                  providerId: wizard?.appointmentSlot?.providerId,
                  specialty: wizard?.state?.specialitySlug,
                },
              });
            }}>
            {labels?.appointments_understood}
          </AppButton>
        </Column>
      </ModalTemplate>
    );
  };

  const renderErrorEmailModal = () => {
    return (
      <ModalTemplate
        className="appointment-cancel-container"
        contentClassName="appointment-cancel-content"
        show={showGeneralError && emailError}
        onHide={() => {
          setShowGeneralError(false);
          setEmailError(false);
        }}
        cross={true}
        hideFooter={true}
        size="sm">
        <div className="modal-error-container">
          <Row className="my-profile-submit-button-row">
            <Icon
              name={Icons.ALERT_PROBLEM}
              width={'40'}
              height={'40'}
              color={colors.alertRed}
              changeViewbox
              viewBox={'0 0 24 24'}
            />
          </Row>
          <Row className="errorPopup-title-row">
            <p
              style={{...fonts.MM, ...fonts.Bold, color: colors.alertRed}}
              className="p-errorPopup">
              {errorMessage}
            </p>
          </Row>
          <Row className="my-profile-submit-button-row">
            <AppButton
              title="Ok"
              variant="primary"
              onClick={() => {
                setShowGeneralError(false);
                setEmailError(false);
              }}>
              Ok
            </AppButton>
          </Row>
        </div>
      </ModalTemplate>
    );
  };

  const renderGeneralErrorModal = () => {
    return (
      <ModalTemplate
        className="appointment-general-error-container"
        contentClassName="appointment-cancel-content"
        show={showGeneralError && !emailError}
        onHide={() => {
          setWizard({});
          history.push('/consultas-online');
        }}
        lockClickOutside={true}
        cross={true}
        hideFooter={true}
        titleStyle={{...fonts.L, color: colors.black}}
        title={labels?.appointments_schedule_error_title}
        size="lg">
        <div className="modal-error-general-container">
          <Row className="modal-general-error-icon-row">
            <Icon
              name={Icons.ALERT_PROBLEM}
              width={'40'}
              height={'40'}
              color={colors.alertRed}
              changeViewbox
              viewBox={'0 0 24 24'}
            />
          </Row>
          <Row className="general-error-popup-subtitle-row">
            <p
              style={{...fonts.MM, ...fonts.Medium, color: colors.alertRed}}
              className="p-errorPopup">
              {labels?.appointments_schedule_error_subtitle}
            </p>
          </Row>
          <div className="general-error-popup-description-row">
            <span
              style={{...fonts.MM, color: colors.black}}
              className="p-errorPopup">
              {labels?.appointments_schedule_error_description_1}{' '}
            </span>
            <a
              style={{...fonts.MM, color: colors.lightBlue}}
              className="telefone-anchor"
              href={`tel:${labels?.appointments_schedule_error_phone}`}>
              {labels?.appointments_schedule_error_phone}
            </a>
            <span
              style={{...fonts.MM, color: colors.black}}
              className="p-errorPopup">
              {' '}
              {labels?.appointments_schedule_error_description_2}
            </span>
          </div>
          <Row className="general-error-submit-button-row">
            <AppButton
              title="Ok"
              className="general-error-ok-button"
              variant="inverted"
              style={{border: `solid 2px ${buStyles.primaryColor}`}}
              onClick={() => {
                setWizard({});
                history.push('/consultas-online');
              }}>
              {labels?.appointments_understood}
            </AppButton>
          </Row>
        </div>
      </ModalTemplate>
    );
  };

  return (
    appointmentSlotDetails && (
      <div className="main-appointment-slot-details">
        <Row className="patient-select-title-row">
          <p className="patient-select-title" style={{...fonts.ML}}>
            {hidePayment
              ? labels?.appointments_schedule_step3_title_no_price
              : labels?.appointments_schedule_step3_title}
          </p>
        </Row>
        <AppForm
          initialValues={{
            patientNumber: '',
            medicalDataPhone:
              user.mobile && user.mobile !== '0' ? user.mobile : '',
            paymentPhone: '',
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => setAppointment(values)}>
          <Row className="appointment-container-margins">
            {renderPatient()}
            {renderMedic()}
            {renderDate()}
            {!editingAppointmentId && renderMedicalData()}
            {wizard.state.specialitySlug &&
              labelSpecialtyAlerts &&
              renderSpecialtyLabel()}
            {!hidePayment && renderPayment()}
          </Row>
          <AppFormSubmitButton
            disabled={disableButton}
            className="appointment-slot-start-appointment-button"
            variant="primary"
            title="">
            <span className="bolder-text appointment-slot-start-appointment-button-text">
              {labels?.appointments_schedule_before_continue_continue}
            </span>
          </AppFormSubmitButton>
        </AppForm>
        {renderErrorEmailModal()}
        {renderGeneralErrorModal()}
        {renderSuccessModal()}
        {renderPendingModal()}
        {isResponsive && (
          <Row className="exit-button-responsive">
            <Link
              onClick={async () => {
                setWizard({});
              }}
              to="/consultas-online"
              className="appointments-schedule-header-content-exit-label"
              style={{
                ...fonts.SM,
                ...fonts.SemiBold,
                color: buStyles?.primaryColor || colors.blue,
              }}>
              {labels?.appointments_schedule_leave}
              <Icon
                className="reimbursement-header-content-close-icon svg-close-button inline-svg-close-button"
                name={Icons.CLOSE}
                width={'12'}
                height={'12'}
                changeViewbox={true}
                strokeWidth={'0.5'}
              />
            </Link>
          </Row>
        )}
      </div>
    )
  );
}

const mapStateToProps = ({
  selectedBu,
  user,
  strings,
  globalStyles,
  availableBus,
  wizard,
}: any) => ({
  user: user.value,
  selectedBu: selectedBu.value,
  buStyles: globalStyles.value,
  labels: strings.value.pt.appointments,
  labelsProfile: strings.value.pt.myProfile,
  availableBus: availableBus.value,
  wizard: wizard.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
  setUser: (value: any) => dispatch(setUser(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(ScheduledAppointmentDetails)
);
